import { useEffect } from "react";
import { useAuth } from "~/context/AuthContext";

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
    CRISP_READY_TRIGGER?: () => void;
  }
}

export default function CrispChat() {
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!import.meta.env.PROD) {
      return;
    }

    const websiteId = import.meta.env.VITE_CRISP_WEBSITE_ID;

    if (!websiteId) {
      console.error("VITE_CRISP_WEBSITE_ID is not configured");
      return;
    }

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;

    window.$crisp.push(["do", "chat:hide"]);

    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;

    script.onload = () => {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:hide"]);
      }
    };

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete window.$crisp;
      delete window.CRISP_WEBSITE_ID;
    };
  }, []);

  useEffect(() => {
    if (!import.meta.env.PROD) {
      return;
    }

    if (!isAuthenticated || !user) {
      return;
    }

    if (window.$crisp) {
      window.$crisp.push(["set", "user:email", [user.email]]);

      if (user.first_name) {
        window.$crisp.push([
          "set",
          "user:nickname",
          [user.first_name + (user.last_name ? ` ${user.last_name}` : "")],
        ]);
      }

      if (user.picture) {
        window.$crisp.push(["set", "user:avatar", [user.picture]]);
      }

      window.$crisp.push([
        "set",
        "session:data",
        [
          [
            ["user_id", user.gid],
            ["team_id", user.team_id?.toString() || ""],
          ],
        ],
      ]);
    }
  }, [isAuthenticated, user]);

  return null;
}
